var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAnything)?_c('li',{staticClass:"data-list__item"},[_c('span',{staticClass:"data-list__item__label"},[_vm._v(_vm._s(_vm.label))]),(_vm.showValue)?_c('span',{staticClass:"data-list__item__data"},[_vm._v(_vm._s(_vm.value))]):_c('hh-data-list',{staticClass:"data-list__item__data-list",attrs:{"items":_vm.item[1]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }